import React from "react";
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Form,
  InputGroup,
  Table,
} from "react-bootstrap";
import { UpdateInfo } from "../CreateUpdatePage";

interface UpdateFileListProps {
  updateInfoList: UpdateInfo[];
  onChange: (updateInfoList: UpdateInfo[]) => void;
  onRequestReload: () => void;
}

function UpdateFileList({
  updateInfoList,
  onChange,
  onRequestReload,
}: UpdateFileListProps) {
  const toggleSelectAll = (checked: boolean) => {
    onChange(
      updateInfoList.map((ui) => {
        if (!ui.allowSelect || ui.include === checked) return ui;

        return { ...ui, include: checked };
      }),
    );
  };

  const getSelectionCount = () => {
    let count = 0;
    updateInfoList?.forEach((entry) => {
      if (entry.include) count++;
    });

    return count;
  };

  return (
    <div className="h-100" style={{ display: "flex", flexDirection: "column" }}>
      <div>
        <ButtonToolbar className="mb-2">
          <ButtonGroup>
            <Button size="sm" onClick={() => onRequestReload()}>
              Reload
            </Button>
          </ButtonGroup>
          <InputGroup className="ms-auto">
            <InputGroup.Text>
              Total selected: {getSelectionCount()} files
            </InputGroup.Text>
          </InputGroup>
        </ButtonToolbar>
      </div>
      <div className="fixed-table-header" style={{ height: "100%" }}>
        <Table size="sm" style={{ fontSize: "80%" }}>
          <thead>
            <tr>
              <th style={{ width: 30, textAlign: "center" }}>
                <Form.Check>
                  <Form.Check.Input
                    defaultChecked={true}
                    onChange={(e) => toggleSelectAll(e.target.checked)}
                    style={{ borderColor: "var(--gray-500)" }}
                  />
                </Form.Check>
              </th>
              <th style={{ width: 30 }}>Fire</th>
              <th style={{ width: 30 }}>RSA</th>
              <th>Number</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {updateInfoList.map((ui) => (
              <tr key={ui.vehicleFileNumber}>
                <td className="shrink-nowrap" style={{ textAlign: "center" }}>
                  <Form.Check>
                    <Form.Check.Input
                      disabled={!ui.allowSelect}
                      checked={ui.include}
                      onChange={(e) =>
                        onChange(
                          updateInfoList.map((x) =>
                            x !== ui ? x : { ...x, include: e.target.checked },
                          ),
                        )
                      }
                      style={
                        ui.allowSelect
                          ? { borderColor: "var(--gray-500)" }
                          : undefined
                      }
                    />
                  </Form.Check>
                </td>
                <td className="shrink-nowrap" style={{ textAlign: "center" }}>
                  <Form.Check>
                    <Form.Check.Input
                      disabled={!ui.allowSelect}
                      checked={ui.isFireService}
                      onChange={(e) =>
                        onChange(
                          updateInfoList.map((x) =>
                            x !== ui
                              ? x
                              : { ...x, isFireService: e.target.checked },
                          ),
                        )
                      }
                    />
                  </Form.Check>
                </td>
                <td className="shrink-nowrap" style={{ textAlign: "center" }}>
                  <Form.Check>
                    <Form.Check.Input
                      disabled={!ui.allowSelect}
                      checked={ui.isRoadAssist}
                      onChange={(e) =>
                        onChange(
                          updateInfoList.map((x) =>
                            x !== ui
                              ? x
                              : { ...x, isRoadAssist: e.target.checked },
                          ),
                        )
                      }
                    />
                  </Form.Check>
                </td>
                <td className="shrink-nowrap">{ui.vehicleFileNumber}</td>
                <td>{ui.message}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default UpdateFileList;
